import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({one: "product"})
export class Product {

	@Field()
	public id: ID;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/Product.ts